
import React from "react";
import { Link } from "react-router-dom";
import DashboardHeader from "@/components/DashboardHeader";
import DashboardTiles from "@/components/DashboardTiles";
import UpcomingGuests from "@/components/UpcomingGuests";
import ActionPanel from "@/components/ActionPanel";
import { guests } from "@/data/mockData";

const Index = () => {
  
  return (
    <main className="flex flex-col min-h-screen bg-background">
      <div className="container mx-auto px-4 py-6">
        <DashboardHeader />
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
          <DashboardTiles />
        </div>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:grid-cols-3">
          <div className="md:col-span-2 space-y-6">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-xl font-semibold">Upcoming Guests</h2>
              <Link to="/explore" className="text-sm text-primary hover:underline">
                View all
              </Link>
            </div>
            <UpcomingGuests guests={guests} />
          </div>
          
          <div className="space-y-6">
            <h2 className="text-xl font-semibold mb-2">Quick Actions</h2>
            <ActionPanel />
          </div>
        </div>
      </div>
    </main>
  );
};

export default Index;
